import { render, staticRenderFns } from "./WillBeneficiariesDrugsDetails.vue?vue&type=template&id=672c80f4"
import script from "./WillBeneficiariesDrugsDetails.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesDrugsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports